import React from "react";
import Header from "../../components/Header";

const TermofUse = () => {
  return (
    <>
    <Header/>
    
    <main>
      {/* breadcrumb start */}
      <section id="h1-breadcrumb">
        <div className="h1-breadcrumb w-full h-fit overflow-hidden relative  pt-[150px] md:pt-[70px]">
          <h1
            data-aos="fade-up"
            className="text-3xl md:text-6xl font-black text-[#3F3D3A] leading-tight text-center"
          >
            Terms &
            <span className="bg-gradient-to-r from-[#D4CB2F] via-[#E6DD57] to-[#55534F] bg-clip-text text-transparent">
              {" "}
              Conditions
            </span>
          </h1>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* blog start  */}
      <section className="w-full py-16 md:py-[80px]" data-aos="fade">
        <div className="theme-container mx-auto w-full text-[14px] md:text-base">
          <p className="mb-4 font-medium">
            These Terms & Conditions (“Terms”) govern your access to and use of
            the S Meera Health website (the “Website”) and the SaaS-based
            healthtech infrastructure we provide (the “Service”). By accessing
            or using the Website or Service, you agree to be bound by these
            Terms.
          </p>
          <p className="mb-2">
            <strong>1. Definitions</strong>
          </p>
          <div>
            <p className="mb-2">
              <strong>“S Meera Health”</strong> refers to S Meera Health,
              the provider of the Services.
            </p>
            <p className="mb-2">
              <strong>“You”</strong> refers to the individual or entity
              accessing or using the Website or Services.
            </p>
            <p className="mb-2">
              <strong>“Content”</strong> refers to any information, data, text,
              software, code, or other materials displayed on or available
              through the Website or Services.
            </p>
            <p className="mb-4">
              <strong>“User”</strong> refers to any individual or entity who
              accesses or uses the Website or Services.
            </p>
          </div>
          <p className="mb-2">
            <strong>2. Use of the Website and Service</strong>
          </p>
          <div>
            <p className="mb-2">
              You may only use the Website and Service for lawful purposes and
              in accordance with these Terms.
            </p>
            <p className="mb-2 font-medium">
              You agree not to use the Website or Service:
            </p>
            <div style={{ paddingLeft: 10 }}>
              <p className="mb-2">
                • In a manner that could damage, disable, overburden, or impair
                the Website or Service.
              </p>
              <p className="mb-2">
                • To interfere with any other user’s enjoyment of the Website or
                Service.
              </p>
              <p className="mb-2">
                • To gain unauthorised access to the Website or Service, or any
                computer systems or networks connected to the Website or
                Service.
              </p>
              <p className="mb-2">
                • To upload, transmit, or store any content that is unlawful,
                harassing, defamatory, obscene, or otherwise objectionable.
              </p>
              <p className="mb-4">
                • To violate any applicable laws or regulations.
              </p>
            </div>
          </div>
          <p className="mb-2">
            <strong>3. User Content</strong>
          </p>
          <div>
            <p className="mb-2">
              You are solely responsible for any content you upload, transmit,
              or store on the Website or Service.
            </p>
            <p className="mb-4">
              You grant S Meera Health Technologies a non-exclusive,
              royalty-free license to use, reproduce, modify, publish, and
              distribute your User Content in connection with the Website and
              Service.
            </p>
          </div>
          <p className="mb-2">
            <strong>4. Intellectual Property</strong>
          </p>
          <div>
            <p className="mb-2">
              The Website and Service, including all Content, are protected by
              copyright, trademark, and other intellectual property laws.
            </p>
            <p className="mb-4">
              You agree not to remove, alter, or obscure any copyright notices
              or other proprietary notices placed on the Website or Service.
            </p>
          </div>
          <p className="mb-2">
            <strong>5. Disclaimers</strong>
          </p>
          <div>
            <p className="mb-2">
              THE WEBSITE AND SERVICE ARE PROVIDED “AS IS” AND WITHOUT
              WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED. S Meera Health
              DISCLAIMS ALL WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
              AND NON-INFRINGEMENT.
            </p>
            <p className="mb-4">
              S Meera Health DOES NOT WARRANT THAT THE WEBSITE OR SERVICE WILL
              BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE CORRECTED, OR
              THAT THE WEBSITE OR SERVICE IS FREE OF VIRUSES OR OTHER HARMFUL
              COMPONENTS.
            </p>
          </div>
          <p className="mb-2">
            <strong>6. Limitation of Liability</strong>
          </p>
          <div>
            <p className="mb-4">
              S Meera Health SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT,
              INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING
              OUT OF OR IN CONNECTION WITH YOUR USE OF THE WEBSITE OR SERVICE.
            </p>
          </div>
          <p className="mb-2">
            <strong>7. Term and Termination</strong>
          </p>
          <div>
            <p className="mb-2">
              These Terms shall remain in full force and effect until terminated
              by you or S Meera Health.
            </p>
            <p className="mb-2">
              S Meera Health may terminate these Terms at any time, with or
              without cause, upon written notice to you.
            </p>
            <p className="mb-4">
              You may terminate these Terms by discontinuing your use of the
              Website and Service.
            </p>
          </div>
          <p className="mb-2">
            <strong>8. Governing Law</strong>
          </p>
          <div>
            <p className="mb-4">
              These Terms shall be governed by and construed in accordance with
              the laws of India in the competent court.
            </p>
          </div>
          <p className="mb-2">
            <strong>9. Entire Agreement</strong>
          </p>
          <div>
            <p className="mb-4">
              These Terms constitute the entire agreement between you and S
              Meera Health with respect to the use of the Website and Service.
            </p>
          </div>
          <p className="mb-2">
            <strong>10. Severability</strong>
          </p>
          <div>
            <p className="mb-4">
              If any provision of these Terms is held to be invalid or
              unenforceable, such provision shall be struck and the remaining
              provisions shall remain in full force and effect.
            </p>
          </div>
          <p className="mb-2">
            <strong>11. Waiver</strong>
          </p>
          <div>
            <p className="mb-4">
              No waiver of any provision of these Terms shall be deemed a
              further or continuing waiver of such provision or any other
              provision.
            </p>
          </div>
          <p className="mb-2">
            <strong>12. Update to Terms</strong>
          </p>
          <div>
            <p className="mb-4">
              S Meera Health may update these Terms at any time by posting the
              amended terms on the Website. Your continued use of the Website or
              Service following the posting of amended Terms constitutes your
              acceptance of the amended Terms.
            </p>
          </div>
          <p className="mb-2">
            <strong>13. Contact Us</strong>
          </p>
          <p>
            If you have any questions about these Terms, please contact us at{" "}
            <a
              className="px-[4px] text-theme font-semibold cursor-pointer"
              href="mailto:support@smeerahealth.com"
              style={{ display: "inline-block" }}
            >
              support@smeerahealth.com
            </a>
          </p>
          <p className="mb-2">
            <strong>14. LEGAL DISCLAIMER</strong>
          </p>
          <div>
            <p className="mb-2">
              By engaging in a transaction with the Company, all customers
              acknowledge and agree to the below mentioned terms. Any violation
              of the below terms may result in legal consequences as per the
              applicable laws.
            </p>
            <p className="mb-2">
              1. No Unauthorised Inducements or Commitments: No person shall,
              directly or indirectly, offer or induce any other person to engage
              in a transaction under false pretences. The Company does not
              assume responsibility for any false commitments or inducements
              made by its agents or telemarketing representatives in relation to
              the sale of any product. In case of any doubt regarding the
              authenticity of any commitment or representation, the same may be
              verified through a confirmation call conducted by the Company
              before any payment is made. Customers also have the right to
              verify within fifteen (15) days of making a payment by contacting
              our customer service at{" "}
              <a
                className="pr-[0px] text-theme font-semibold cursor-pointer"
                href="tel:919711300776"
                style={{ display: "inline-block" }}
              >
                0261 360 0552
              </a>{" "}
              or via email at{" "}
              <a
                className="pl-[0px] text-theme font-semibold cursor-pointer"
                href="mailto:hello@smeerahealth.com"
                style={{ display: "inline-block" }}
              >
                support@smeerahealth.com
              </a>
              . No agreement shall be challenged on any grounds after the
              expiration of fifteen (15) days from the date of issuance or from
              the commencement of risk coverage.
            </p>
            <p className="mb-4">
              2. Third-Party Payments: The Company shall not be held responsible
              for payments made by the customer to any third parties / any
              payment made by third party on behalf of the customer. If a
              customer makes a payment to any third party under any influence or
              coercion, the responsibility lies solely with the customer. The
              Company disclaims all liability in such circumstances. The Company
              does not accept cash payments for any transactions. Customers are
              advised to refrain from making cash transactions under any
              circumstances, as the Company will not be held accountable for
              such payments.
            </p>
          </div>
          <p className="mb-2">
            <strong>15. For Group Insurance and Personal Accident Rider</strong>
          </p>
          <div>
            <p className="mb-4">
              Age limit will be 18-65 years only for primary holder
            </p>
          </div>
          <p className="mb-2">
            <strong>16. For OPD Wellness Benefits</strong>
          </p>
          <div>
            <p className="mb-4">Age limit will be 0-85 years</p>
          </div>
        </div>
      </section>
      {/* blog end  */}
    </main>
    </>
  );
};

export default TermofUse;
